import * as React from 'react'
import cx from 'classnames'
import Text from 'components/Text'
import SubmissionViewModel from 'jobs/creation/SubmissionViewModel'
import {
  SubmissionSection,
  SubmissionSectionHeader,
} from '../SubmissionSection'
import { observer } from 'mobx-react'
import styles from './Pricing.sass'

interface PricingProps {
  vm: SubmissionViewModel
  /**
   * If `true`, will render a section title and put
   * the items in a box. The box will stretch.
   */
  boxed?: boolean
  compact?: boolean
}

/**
 * The Pricing
 */
export default observer(function Pricing({ vm, boxed, compact }: PricingProps) {
  const pricing = vm.summary?.pricing
  if (!pricing) {
    return null
  }

  const items = (
    <>
      {pricing.discount && (
        <PricingItem highlighted label="Discount" value={pricing.discount} />
      )}
      <PricingItem label="Total" value={pricing.total} />
      <PricingItem label="Amount Due Now" value={pricing.amountDueNow} />
    </>
  )

  return (
    <SubmissionSection compact={compact}>
      {boxed && <SubmissionSectionHeader label="Summary" compact={compact} />}
      {boxed ? <Box>{items}</Box> : items}
    </SubmissionSection>
  )
})

interface PricingItemProps {
  label: string
  value: string
  highlighted?: boolean
}

/**
 " Pricing Item
 */
function PricingItem({ label, value, highlighted }: PricingItemProps) {
  if (!value) {
    return null
  }

  return (
    <div className={cx(styles.pricingItem, highlighted && styles.highlighted)}>
      <div className={styles.itemLabel}>{label}</div>
      <div
        className={styles.itemValue}
        data-test={`pricing-item-${label}-value`}
      >
        <Text text={value} />
      </div>
    </div>
  )
}

interface BoxProps {
  children?: React.ReactNode
}

/**
 " Box
 */
function Box({ children }: BoxProps) {
  return <div className={styles.box}>{children}</div>
}
